// @ts-nocheck
// /pick — "אתם בוחרים את סדר הפרקים" (Shlomo, 8.10.2026).
//
// The reader sees the 12 chapters in one line each and picks the one that
// speaks to them. Every chapter, the first included, opens only after the
// email (Shlomo, 12.10 13:30, withdrawing the morning's "taste" rule): the
// first PICK_LIMIT picks open for free inside the book (chapter_grants,
// migration 0048); from the third on, the door: the live offer. A signed-out visitor gets the same list
// plus a magic-link box, and lands back here after the login; the chapter
// they tapped before the login is remembered and opened for them. Every step
// is measured (site_events: pick_view / pick_login /
// pick_choose / pick_gate) and summarised in the 09:00 report.
//
// Design round 12.10 (Shlomo): bigger text everywhere, the "why" statement
// in bold, the explanation glued to the title, no row looks "the only one".
// Second round the same day: one button, one word ("לפתוח"), for all 12 rows;
// listening and reading are equals, so no "לקריאה" anywhere.

import { useEffect, useState } from "react";
import { supabase } from "../lib/supabase";
import { useAuth } from "../lib/useAuth";
import { usePicks } from "../lib/usePicks";
import { logSiteEvent } from "../lib/siteEvents";
import { CHAPTER_PICKS, PICK_INTRO, PICK_TITLE, PICK_WHY, PICK_WHY_SUB } from "../data/chapterPicks";
import { WELCOME_DISMISSED_KEY } from "./WelcomePage";

const styles = `
.pk-wrap { max-width: 720px; margin: 0 auto; padding: 0 16px 48px; direction: rtl; font-family: 'Heebo', sans-serif; color: #2D1B10; font-size: 16px; }
.pk-band { background: linear-gradient(135deg, #5C3D2E, #7a5238); color: #fff; text-align: center; padding: 22px 18px 20px; margin: 0 -16px 0; }
.pk-band h1 { font-family: 'Frank Ruhl Libre', serif; font-size: 21px; font-weight: 700; margin: 0; line-height: 1.15; opacity: .92; }
.pk-band h2 { font-family: 'Frank Ruhl Libre', serif; font-size: 23px; font-weight: 700; margin: 10px 0 0; color: #F0C27B; line-height: 1.2; }
.pk-band p { font-size: 18px; line-height: 1.5; margin: 6px auto 0; max-width: 600px; color: #F6EEE2; }
.pk-why { background: #FFF6E6; border-top: 3px solid #F0C27B; border-bottom: 3px solid #F0C27B; margin: 0 -16px 18px; padding: 16px 18px 14px; text-align: center; }
.pk-why h3 { font-family: 'Frank Ruhl Libre', serif; font-size: 26px; font-weight: 800; line-height: 1.3; color: #5C3D2E; margin: 0 0 8px; }
.pk-why p { font-size: 16.5px; line-height: 1.6; color: #3f2c1f; margin: 0; }
.pk-status { background: #FFF8F0; border: 1px solid #E8DCC8; border-radius: 12px; padding: 12px 14px; margin: 0 0 14px; font-size: 16px; line-height: 1.55; }
.pk-status b { color: #5C3D2E; }
.pk-h3 { font-family: 'Frank Ruhl Libre', serif; font-size: 21px; color: #5C3D2E; margin: 6px 0 10px; }
.pk-row { display: flex; gap: 10px; align-items: center; padding: 11px 10px; border: 1px solid #EFE6D8; border-radius: 12px; margin-bottom: 8px; background: #FFFDF9; }
.pk-num { flex: none; width: 34px; height: 34px; border-radius: 50%; background: #5C3D2E; color: #F0C27B; font-family: 'Frank Ruhl Libre', serif; font-weight: 700; font-size: 17px; display: flex; align-items: center; justify-content: center; }
.pk-row.picked .pk-num { background: #A0704A; color: #fff; }
.pk-row.picked { border-color: #A0704A; background: #FFF6EA; }
.pk-row.locked { opacity: .8; }
.pk-txt { flex: 1; min-width: 0; }
.pk-title { font-family: 'Frank Ruhl Libre', serif; font-size: 18px; font-weight: 700; color: #5C3D2E; line-height: 1.25; }
.pk-line { font-size: 16px; line-height: 1.5; color: #3f2c1f; margin-top: 3px; }
.pk-btn { flex: none; align-self: center; border: none; border-radius: 10px; padding: 12px 14px; font-family: 'Heebo', sans-serif; font-size: 16px; font-weight: 700; cursor: pointer; background: linear-gradient(135deg, #A0704A, #D4875A); color: #fff; box-shadow: 0 4px 12px rgba(160,112,74,.28); white-space: nowrap; }
.pk-btn.lock { background: #EDE4D6; color: #6b5444; box-shadow: none; }
.pk-btn:disabled { opacity: .6; cursor: default; }
.pk-login { background: #FFF8F0; border: 2px solid #E8DCC8; border-radius: 14px; padding: 16px; margin: 16px 0 18px; scroll-margin-top: 16px; }
.pk-login.hot { border-color: #D4875A; box-shadow: 0 0 0 4px rgba(212,135,90,.18); }
.pk-login h3 { margin: 0 0 8px; font-family: 'Frank Ruhl Libre', serif; font-size: 21px; line-height: 1.3; color: #5C3D2E; }
.pk-login p { margin: 0 0 12px; font-size: 16px; line-height: 1.6; color: #3f2c1f; }
.pk-form { display: flex; gap: 8px; flex-wrap: wrap; }
.pk-input { flex: 1; min-width: 200px; padding: 12px 12px; border: 2px solid #E8DCC8; border-radius: 10px; font-size: 16px; direction: ltr; text-align: left; background: #fff; font-family: 'Heebo', sans-serif; }
.pk-msg { font-size: 16px; line-height: 1.6; padding: 10px 12px; border-radius: 10px; margin-top: 8px; }
.pk-msg.ok { background: #FFF6E6; color: #5C3D2E; border: 1px solid #F0C27B; }
.pk-msg.err { background: #FFF6E6; color: #5C3D2E; border: 1px solid #A0704A; }
.pk-door { background: linear-gradient(135deg, #5C3D2E, #3a2419); color: #fff; border-radius: 16px; padding: 20px 18px; margin: 18px 0 8px; text-align: center; }
.pk-door h3 { font-family: 'Frank Ruhl Libre', serif; font-size: 22px; margin: 0 0 6px; }
.pk-door p { margin: 0 0 12px; font-size: 16px; line-height: 1.6; opacity: .95; }
.pk-door a { display: inline-block; background: linear-gradient(135deg, #A0704A, #D4875A); color: #fff; text-decoration: none; border-radius: 12px; padding: 12px 22px; font-weight: 700; font-size: 16px; }
.pk-foot { text-align: center; font-size: 15px; color: #8B7355; margin-top: 22px; }
.pk-foot a { color: #A0704A; font-weight: 600; text-decoration: none; }
`;

const POS_KEY = "ei_book_pos";
const INTENT_KEY = "ei_pick_intent";
const PRICE = "89 ₪";

function openChapter(n: number) {
  // The chapter travels in the URL (App reads ?ch= before the saved
  // position). Pickers already read the long explanation here, so the
  // first-time welcome page is skipped for them.
  try {
    localStorage.setItem(POS_KEY, JSON.stringify({ chapter: n, started: false, scrollY: 0 }));
    localStorage.setItem(WELCOME_DISMISSED_KEY, "1");
  } catch {}
  window.location.href = "/?ch=" + n + "&from=pick";
}

function readIntent(): number | null {
  // "n:timestamp"; a tap older than an hour is not a wish any more.
  try {
    const [a, b] = (localStorage.getItem(INTENT_KEY) || "").split(":");
    const v = parseInt(a, 10), t = parseInt(b, 10);
    if (!(v >= 1 && v <= 12) || !(Date.now() - t < 3600 * 1000)) { localStorage.removeItem(INTENT_KEY); return null; }
    return v;
  } catch { return null; }
}

export function PickPage() {
  const { user, loading: authLoading } = useAuth();
  const { picks, loading: picksLoading, refresh } = usePicks();
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState<"idle" | "sending" | "sent" | "error">("idle");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState<number | null>(null);
  const [gateLogged, setGateLogged] = useState(false);
  const [intent, setIntent] = useState<number | null>(readIntent);
  const [autoDone, setAutoDone] = useState(false);

  useEffect(() => {
    logSiteEvent("pick_view");
    try { window.clarity && window.clarity("set", "page", "pick"); } catch {}
  }, []);

  const src = (() => {
    try { return new URLSearchParams(window.location.search).get("s") || localStorage.getItem("ei_site_src"); } catch { return null; }
  })();

  const atDoor = !!user && !picks.full && picks.left === 0 && picks.chapters.length > 0;
  useEffect(() => {
    if (atDoor && !gateLogged) {
      logSiteEvent("pick_gate");
      setGateLogged(true);
    }
  }, [atDoor, gateLogged]);

  const sendLink = async (e) => {
    e.preventDefault();
    const t = email.trim();
    if (!t) return;
    setSent("sending"); setErr("");
    const { error } = await supabase.auth.signInWithOtp({
      email: t,
      options: { emailRedirectTo: window.location.origin + "/pick" },
    });
    if (error) { setSent("error"); setErr(error.message || "שגיאה בשליחה, נסו שוב."); }
    else { setSent("sent"); logSiteEvent("pick_login"); }
  };

  const wantChapter = (n: number) => {
    // Signed-out tap on a chapter: remember it, point to the email box. After the magic link brings them back, it opens by itself.
    try { localStorage.setItem(INTENT_KEY, n + ":" + Date.now()); } catch {}
    setIntent(n);
    const box = document.querySelector(".pk-login");
    box?.scrollIntoView({ behavior: "smooth", block: "center" });
    setTimeout(() => document.querySelector(".pk-input")?.focus({ preventScroll: true }), 450);
  };

  const choose = async (n: number) => {
    if (!user) { wantChapter(n); return; }
    if (picks.full || picks.chapters.includes(n)) { openChapter(n); return; }
    if (picks.error) { await refresh(); return; }
    setBusy(n);
    const { error } = await supabase.rpc("pick_chapter", { _chapter: n, _src: src });
    setBusy(null);
    if (error) { await refresh(); return; }
    logSiteEvent("pick_choose");
    try { window.clarity && window.clarity("event", "pick_choose"); } catch {}
    openChapter(n);
  };

  // Back from the magic link with a remembered chapter: open it.
  useEffect(() => {
    if (!user || picksLoading || autoDone) return;
    const n = readIntent();
    if (!n) return;
    setAutoDone(true);
    try { localStorage.removeItem(INTENT_KEY); } catch {}
    if (picks.full || picks.chapters.includes(n) || picks.left > 0) choose(n);
  }, [user, picksLoading]);

  const left = picks.full ? 99 : picks.left;
  const pickedCount = picks.chapters.length;
  const intentTitle = intent ? CHAPTER_PICKS.find((c) => c.n === intent)?.title : null;

  return (
    <div className="pk-wrap">
      <style dangerouslySetInnerHTML={{ __html: styles }} />
      <div className="pk-band">
        <h1>שאלת האריה - סדנה בספר</h1>
        <h2>{PICK_TITLE}</h2>
        {PICK_INTRO.map((t, i) => <p key={i}>{t}</p>)}
      </div>

      <div className="pk-why">
        <h3>{PICK_WHY}</h3>
        <p>{PICK_WHY_SUB}</p>
      </div>

      {!authLoading && !user && (
        <div className="pk-status">
          <b>שני פרקים לבחירתכם, בחינם.</b> לוחצים על פרק, רושמים מייל, והוא נפתח. להאזנה או לקריאה.
        </div>
      )}

      {user && picksLoading && (
        <div className="pk-status">רגע, בודק אילו פרקים פתוחים לך...</div>
      )}
      {user && !picksLoading && picks.error && (
        <div className="pk-status">לא הצלחתי לבדוק אילו פרקים פתוחים לך. <b><a href="/pick" style={{ color: "#A0704A" }}>לרענן את הדף</a></b>, ואם זה חוזר, לכתוב לשלמה.</div>
      )}
      {user && !picksLoading && !picks.error && (
        <div className="pk-status">
          {picks.full ? (
            <>יש לך גישה לכל הפרקים. <b>בחר/י מאיפה להתחיל.</b></>
          ) : pickedCount === 0 ? (
            <><b>שני פרקים לבחירתך, בחינם.</b> להאזנה או לקריאה.</>
          ) : left > 0 ? (
            <>בחרת את פרק {picks.chapters.join(" ו-")}. <b>נשאר לך פרק נוסף לבחור.</b></>
          ) : (
            <>בחרת את פרקים {picks.chapters.join(" ו-")}. הם פתוחים לך בספר. <b>השאר מחכים אחרי הדלת.</b></>
          )}
        </div>
      )}

      <div className="pk-h3">מה יש בכל פרק</div>
      {CHAPTER_PICKS.map((c) => {
        const picked = picks.chapters.includes(c.n) || picks.full;
        const unknown = !!user && (picksLoading || !!picks.error);
        const locked = !!user && !unknown && !picked && left === 0;
        return (
          <div key={c.n} className={"pk-row" + (picked && user ? " picked" : "") + (locked ? " locked" : "")}>
            <div className="pk-num">{c.n}</div>
            <div className="pk-txt">
              <div className="pk-title">{c.title}</div>
              <div className="pk-line">{c.line}</div>
            </div>
            {locked ? (
              <a className="pk-btn lock" href="/b?s=pick" style={{ textDecoration: "none" }}>{PRICE}</a>
            ) : (
              <button className="pk-btn" disabled={busy !== null || unknown} onClick={() => choose(c.n)}>{busy === c.n ? "פותח..." : unknown ? "רגע..." : "לפתוח"}</button>
            )}
          </div>
        );
      })}

      {!authLoading && !user && (
        <div className={"pk-login" + (intent ? " hot" : "")}>
          {intent ? (
            <h3>בחרתם את פרק {intent}: {intentTitle}. רשמו את המייל שלכם והוא ייפתח לכם.</h3>
          ) : (
            <h3>לפתיחת הפרק שבחרתם, רשמו את המייל שלכם.</h3>
          )}
          <p>נשלח לכם למייל קישור כניסה (בלי סיסמה). לוחצים עליו, חוזרים לכאן, והפרק שבחרתם נפתח. דרך המייל תוכלו גם לחזור ולהמשיך, להאזין או לקרוא.</p>
          {sent === "sent" ? (
            <div className="pk-msg ok">נשלח מייל מ-eiforall.com. פותחים אותו, לוחצים על הכפתור, וחוזרים לכאן.</div>
          ) : (
            <form className="pk-form" onSubmit={sendLink}>
              <input className="pk-input" type="email" placeholder="name@example.com" value={email} onChange={(e) => setEmail(e.target.value)} required />
              <button className="pk-btn" type="submit" disabled={sent === "sending"}>שלחו לי קישור</button>
            </form>
          )}
          {sent === "error" && <div className="pk-msg err">{err}</div>}
        </div>
      )}

      {atDoor && (
        <div className="pk-door">
          <h3>הפרקים שבחרת פתוחים לך. עשרה מחכים.</h3>
          <p>הסדנה כולה, 12 מפגשים, בקולי, בקצב שלך, לתמיד. {PRICE}.</p>
          <a href="/b?s=pick">להמשיך לסדנה כולה</a>
        </div>
      )}

      <div className="pk-foot"><a href="/about">שלמה אלפנבוים</a> · שאלת האריה - סדנה בספר · eiforall.com</div>
    </div>
  );
}
